const MobileReject = () => {
    return(
        <div className="wrapper gradientBody">
        <h1>Lmao, I'm not formatting this for mobile.  Come back later or use a computer.</h1>   
        </div>
    )
}

export default MobileReject